import { createContext } from 'react';

type Activity = {
  algo: {
    id: string;
  };
};

export const CurrentActivityContext = createContext<Activity | null>(null);

export const CurrentActivityContextProvider: React.FC<{
  activity: Activity;
}> = ({ activity, children }) => {
  return (
    <CurrentActivityContext.Provider value={activity}>
      {children}
    </CurrentActivityContext.Provider>
  );
};
